import React from 'react';
import style from '../../assets/css/policy.css';

function Cookies() {
    return (
        <main id="policy">
            <div className="wrapper">
                <h1>
                    Политика за използване на „бисквитки“
                </h1>
                <p>
                    Уеб сайтът www.avtoobuchenie.bg, използва „бисквитки“ с цел идентификация на всеки отделен потребител,
                    по този начин се събира анонимна статистика, която дава информация как посетителите ползват уеб сайта.
                    Тази информация ни дава насоки и ни помага да подобрим структурата на уеб сайта.
                </p>
                <h6>
                    1. Какво са „бисквитки“ ?
                </h6>
                <p>
                    „Бисквитките“ са малки текстови файлове, които се запазват на Вашият компютър или мобилно устройство, когато посещавате даден уеб сайт. Те позволяват на уеб сайта да запаметява Вашите действия и предпочитания (като например потребителско име, език, размер на шрифта и други настройки за показване) за определен период от време, за да не се налага да ги въвеждате всеки път, когато посещавате уеб сайта или преминавате от една страница към друга. Събраната информация се ползва за разпознаване на потребителя и подобряване на работата със сайта.
                </p>
                <p>
                    Чрез използването на нашия уеб сайт, вие се съгласявате, че <a href="https://www.avtoobuchenie.bg">www.avtoobuchenie.bg</a> може да запази „бисквитки“ във Вашия компютър или мобилно устройство.
                </p>
                <h6>
                    2. Какви видове „бисквитки“ използваме?
                </h6>
                <p>
                    Ние използваме два вида „бисквитки“: сесийни и постоянни.
                    Сесийните „бисквитки“ са временни файлове, които остават в терминал до завършването на потребителската сесия или затваряне на приложението.
                    Постоянните „бисквитки“ остават на терминала на потребителя за срока, определен от параметрите на „бисквитката“ или докато не се изтрият ръчно от потребителя.
                </p>
                <h6>
                    3. „Бисквитките“ и личните данни
                </h6>
                <p>
                    Техническата информация, която събираме въз основа на „бисквитките“, не представлява лични данни по смисъла на Общ регламент за защита на личните данни (Регламент (ЕС) 2016/679 за защита на личните данни), тъй като същата не е в достатъчна степен индивидуализираща. Нейното използване се налага с цел функционирането на уебсайта, събиране на необходима информация, включително изискуема по закон, гарантиране на сигурността на ползвателите на уеб сайта, както и за подобряване на услугите, които Ви предоставяме.
                </p>
                <h6>
                    4. Как да изключите „бисквитките“ ?
                </h6>
                <p>
                    Всички съвременни браузъри ви позволяват да променяте настройките за „бисквитки“. Обикновено можете да намерите тези настройки в меню „опции“ или „предпочитания“ на вашия браузър.
                    Ако искате да блокирате „бисквитките“, някои функции на уеб сайта ще бъдат спрени, а това може да създаде някои неизправности или грешки при използването на нашият уеб сайт. Например, блокирането на „бисквитките“ може да Ви попречи да използвате услугите на уеб сайта.
                </p>
                <p>
                    В случай, че сте съгласни с тези ограничения и искате да блокирате „бисквитките“, следвайте инструкциите по-долу.
                    Повечето браузъри са настроени по подразбиране да приемат „бисквитки“, но можете да промените
                    Вашите настройки за блокиране на някои или всички „бисквитки“.
                    <br />
                    Изберете Вашия браузър от списъка по-долу, за да видите инструкциите, които трябва да следвате, след като отворите браузъра.
                    <br />
                    <br />

                    <strong>Microsoft Internet Explorer 9</strong> (операционна система Windows 7)
                    <br />
                    - щракнете върху иконата за настройки (горе вдясно)
                    <br />
                    - щракнете върху Опции за интернет
                    <br />
                    - Щракнете върху Поверителност и след това изберете опциите
                    <br />
                    - Щракнете на Прилагам и след това на ОК, за да съхраните предпочитанията си

                    <br />
                    <br />

                    <strong>Google Chrome</strong>
                    <br />
                    - Щракнете върху иконата с ключ и изберете Опции от списъка
                    <br />
                    - Щракнете върху раздела “Разширени настройки“
                    <br />
                    - Щракнете върху настройки на съдържанието от раздел Поверителност.
                    <br />
                    - Изберете настройките, които искате
                    <br />
                    - Щракнете върху X, за да затворите

                    <br />
                    <br />

                    <strong>Сафари</strong>
                    <br />
                    - Изберете Предпочитания
                    <br />
                    - Щракнете върху панела за поверителност
                    <br />
                    - Изберете настройките, които искате
                    <br />
                    - Щракнете върху X, за да затворите

                    <br />
                    <br />

                    <strong>Mozilla Firefox</strong>
                    <br />
                    - Изберете Инструменти от главната лента, след това Опции
                    <br />
                    - Щракнете върху раздел Поверителност
                    <br />
                    - Изберете настройките, които искате
                    <br />
                    - Щракнете върху ОК, за да затворите

                    <br />
                    <br />

                    <strong>ВАЖНО!</strong> Отказът от „бисквитки“ от страна на Потребителя може да доведе до ограничаване на функционалността или до невъзможност да се използват услугите на уеб сайта.

                </p>

            </div>
        </main>
    )
}

export default Cookies;